import { z } from "zod"

import { Err } from "@pacote/result"
import { BaseApiErrorResponse, baseApiResponseSchema } from "./api-config"
import { withAuthClientFetcher } from "./base-fetchers"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

const infoMessageList = z.array(
  z.object({
    idMessage: z.number(),
    readFlag: z.number(),
    deleteFlag: z.number().optional(),
    visionFlag: z.number().optional(),
    confirmFlag: z.number(),
    category: z.number().optional(),
    sender: z.string().optional(),
    priority: z.number().optional(),
    notificationGGPriority: z.number().optional(),
    displayLimit: z.number().optional(),
    insertDate: z.string().optional(),
    typeMessage: z.number().optional(),
    promotionalTypeEndDate: z.string().optional(),
    matter: z.string().optional(),
    text: z.string(),
    idFamily: z.number().optional(),
  }),
)
const messagesResponseSchema = baseApiResponseSchema.extend({
  infoMessageList,
})

const messagesErrorResponseSchema = z.object({
  status: z.string(),
  requestId: z.string(),
  error: z.object({
    type: z.string(),
    message: z.string(),
  }),
})

type MessagesServiceResponse = z.infer<typeof messagesResponseSchema>

type InfoMessageList = MessagesServiceResponse["infoMessageList"]

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/

const messagesServiceEndpoint = "/inbox-ms/ms/inbox/messages"

/* -------------------------------------------------------------------------------------------------
 * fetcher
 * -----------------------------------------------------------------------------------------------*/

const messagesFetcher = async () => {
  try {
    return await withAuthClientFetcher<
      MessagesServiceResponse,
      BaseApiErrorResponse
    >({
      url: messagesServiceEndpoint,
      params: {
        category: "1",
        period: "0",
      },
      successSchemaValidator: messagesResponseSchema,
      errorSchemaValidator: messagesErrorResponseSchema,
    })
  } catch {
    return Err({})
  }
}

export { messagesFetcher }
export type { InfoMessageList }
